// extracted by mini-css-extract-plugin
export default {"cls1":"Uls8UEMtpQwKEWUHoMA5","cls2":"TwFdG9wSkC9tcoy7ghFh Uls8UEMtpQwKEWUHoMA5"};